<template>
    <div class="modal fade" id="costumModalpeta" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Pengaturan Dokumen</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify">
                    <p>
                    <div class="row">
                        <div class="col-sm-12" style="display: none;">
                            <label>id</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-border-all"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm" id="id" name="id"
                                    placeholder="id" v-model="id">
                            </div>
                        </div>
                        <div class="col-sm-12" style="display: none;">
                            <label>Parent</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-border-all"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm" id="id_parent"
                                    name="id_parent" placeholder="Parent" v-model="id_parent">
                            </div>
                        </div>
                        <div class="col-sm-12" style="display: none;">
                            <label>Level</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-border-all"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm" id="level" name="level"
                                    placeholder="Level" v-model="level">
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <label>Nama Dokumen / Folder <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-border-all"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="nama" name="nama"
                                    placeholder="Nama Dokumen / Folder" v-model="nama">
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <label>Urutan Dokumen <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-border-all"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm" id="urut" name="urut"
                                    placeholder="Urutan Dokumen" v-model="urut">
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <label>Jenis Dokumen <small class="text-info"> (*wajib
                                    dipilih)</small></label>
                            <v-select :options="jenismenu" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedjenismenu" @update:modelValue="onjenismenuChange"
                                style="background-color: #ffffff;"></v-select>
                        </div>
                        <div class="col-sm-6">
                            <label>Status Tampil Data</label>
                            <v-select :options="tampilpublik" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedStatusTampil" @update:modelValue="onStatusTampilChange"
                                style="background-color: #ffffff;"></v-select>
                        </div>
                        <div class="col-sm-12 float-left">&nbsp;</div>
                        <div class="col-sm-12" :style="[(selectedjenismenu == 2 ? ':block' : 'display:none')]">
                            <div id="drag_drop" @dragover="dragover" @dragleave="dragleave" @drop="drop">Drag & Drop
                                File Disini</div>
                        </div>
                        <div class="col-sm-12" :style="[(selectedjenismenu == 2 ? ':block' : 'display:none')]">
                            <input type="file" multiple name="file" id="fileInput" class="hidden-input"
                                @change="onChange" ref="file" accept="application/pdf" />
                            <br>
                            <div class="row" v-if="files.length">
                                <div v-for="file in files" :key="file.name" class="row">
                                    <div class="col-sm-10 float-left">
                                        {{ file.name }}
                                        <input type="hidden" class="form-control form-control-sm"
                                            :id="'pic' + files.indexOf(file)" placeholder="File Beranda">
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <button type="button" class="btn btn-sm btn-danger3 float-right text-white"
                                            @click="remove(files.indexOf(file))" data-toggle="tooltip"
                                            data-placement="left" title="Hapus file.."><i
                                                class="fas fa-window-close"></i></button>
                                    </div>
                                    <div class="col-sm-12">
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" aria-valuenow="0"
                                                aria-valuemin="0" aria-valuemax="100" style="width:0%"
                                                :id="'persennyapic' + files.indexOf(file)">
                                                <span :id="'tulisanpersenpic' + files.indexOf(file)">0%</span>
                                            </div>
                                        </div>
                                        <br>
                                        <span class="text-success" :id="'suksesnyapic' + files.indexOf(file)"></span>
                                    </div>
                                </div>
                                <div class="col-sm-12" v-if="files.length">
                                    <button type="button" class="btn btn-sm btn-success float-left text-white lebar2"
                                        @click="upload()" data-toggle="tooltip" data-placement="left"
                                        title="Update data.."><i class="fas fa-upload"></i>
                                        Upload Data</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12" :style="[(selectedjenismenu == 2 ? ':block' : 'display:none')]">&nbsp;
                        </div>
                        <div class="col-sm-12" :style="[(selectedjenismenu == 3 ? ':block' : 'display:none')]">
                            <label>Tautan Dokumen <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-border-all"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="tautan" name="tautan"
                                    placeholder="Tautan Dokumen" v-model="tautan">
                            </div>
                        </div>
                    </div>
                    </p>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" v-if="(this.id == null)" class="btn btn-success3 btn-sm lebar2 text-white"
                        @click="simpanlayer()"><i class="fas fa-plus-square"></i>
                        Simpan</button>
                    <button type="button" v-if="(this.id != null)" class="btn btn-success3 btn-sm lebar2 text-white"
                        @click="updatelayer()"><i class="fa fa-check-circle"></i>
                        Update</button>
                    <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" data-dismiss="modal"> <i
                            class="far fa-times-circle"></i>
                        Batal</button>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Bank Dokumen Infrastruktur</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item active">Pengaturan Dokumen</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="col-sm-12" style="display: none;">
                                <label>kodetemp</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fas fa-border-all"></i></span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" id="kodetemp"
                                        name="kodetemp" placeholder="kodetemp">
                                </div>
                            </div>
                            <button type="button" class="btn btn-success3 btn-sm text-white" @click="prosesdata()"
                                data-toggle="tooltip" data-placement="left" title="Proses.." id="prosesdata"
                                style="display: none;">
                                <i class="fas fa-plus"></i> Proses
                            </button>
                            <button type="button" class="btn btn-success3 btn-sm text-white"
                                @click="tambahdata(null, 1)" data-toggle="tooltip" data-placement="left"
                                title="Tambah Level 1 Dokumen..">
                                <i class="fas fa-plus"></i> Tambah Level 1 Dokumen
                            </button>
                            <ul id="tree1" style="cursor: pointer;font-size: small !important;">
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">&nbsp;</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-12 wow fadeInDown">&nbsp;</div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-12 wow fadeInDown">&nbsp;</div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    components: {
        Footer, NavBar, Menu, vSelect, swal
    },
    data() {
        return {
            halamanloading: true,
            validasi: false,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            datapesan: '',
            datamaster: [],
            carikata: '',
            folder_foto: process.env.VUE_APP_URL_API + 'parastapainnovation_dokumen-Dokumen?f=',
            nama: '',
            tautan: '',
            urut: '',
            id: '',
            id_parent: null,
            level: '',
            jenismenu: [],
            datajenismenu: [],
            defaultSelectedjenismenu: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedjenismenu: '',
            filenya_dokumen: '',
            tampilpublik: [],
            datatampilpublik: [],
            defaultSelectedStatusTampil: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedtampilpublik: '',
            isDragging: false,
            files: [],
        }
    },
    computed: {
        filteredKataData() {
            const filteredWorkers = this.carikata === ""
                ? this.datamaster
                : this.datamaster.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
            return filteredWorkers;
        },
        JumlahfilteredKataData() {
            var jumlah = 0;
            try {
                if (this.filteredKataData === undefined) {
                    jumlah = 0;
                } else {
                    jumlah = this.filteredKataData.length;
                }
            }
            catch {
                jumlah = 0;
            }
            return jumlah;
        },
    },
    methods: {
        onjenismenuChange(a) {
            try {
                this.selectedjenismenu = this.jenismenu[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onStatusTampilChange(a) {
            try {
                this.selectedtampilpublik = this.tampilpublik[a].tag;
            }
            catch (err) {
                return;
            }
        },
        async AmbilDataReff() {
            this.halamanloading = true;
            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIDataSingel.get("parastapainnovation_admindokumen-GetJenisMenu?random=" + random).then(
                Response => {
                    this.datajenismenu = [];
                    this.jenismenu = [];
                    this.datajenismenu = Response.data.content.data;
                    this.datajenismenu.forEach((item) => {
                        this.jenismenu.push({
                            label: item.nama,
                            code: this.datajenismenu.indexOf(item) + 1,
                            tag: item.id,
                        });
                    });
                    this.jenismenu.unshift({
                        label: 'Pilih Data',
                        code: 0,
                        tag: '',
                    });
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

            this.halamanloading = true;
            var random = Math.random();
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                console.log(error);
            });

            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });

            await mainAPI2.get("parastapainnovationreff-GetStatusTampil?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datatampilpublik = [];
                        this.tampilpublik = [];
                        this.datatampilpublik = Response.data.content.data;
                        this.datatampilpublik.forEach((item) => {
                            this.tampilpublik.push({
                                label: item.nama,
                                code: this.datatampilpublik.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.tampilpublik.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
        },
        InisialisasiTree() {
            $.fn.extend({
                treed: function (o) {

                    var openedClass = 'fas fa-minus';
                    var closedClass = 'fas fa-plus';

                    if (typeof o != 'undefined') {
                        if (typeof o.openedClass != 'undefined') {
                            openedClass = o.openedClass;
                        }
                        if (typeof o.closedClass != 'undefined') {
                            closedClass = o.closedClass;
                        }
                    };

                    //initialize each of the top levels
                    var tree = $(this);
                    tree.addClass("tree");
                    tree.find('li').has("ul").each(function () {
                        var branch = $(this); //li with children ul
                        branch.prepend("<i class='indicator glyphicon " + closedClass + "'></i>");
                        branch.addClass('branch');
                        branch.on('click', function (e) {
                            if (this == e.target) {
                                var icon = $(this).children('i:first');
                                icon.toggleClass(openedClass + " " + closedClass);
                                $(this).children().children().toggle();
                            }
                        })
                        branch.children().children().toggle();
                    });
                    //fire event from the dynamically added icon
                    tree.find('.branch .indicator').each(function () {
                        $(this).on('click', function () {
                            $(this).closest('li').click();
                        });
                    });
                    //fire event to open branch if the li contains an anchor instead of text
                    tree.find('.branch>a').each(function () {
                        $(this).on('click', function (e) {
                            $(this).closest('li').click();
                            e.preventDefault();
                        });
                    });
                    //fire event to open branch if the li contains a button instead of text
                    tree.find('.branch>button').each(function () {
                        $(this).on('click', function (e) {
                            $(this).closest('li').click();
                            e.preventDefault();
                        });
                    });
                }
            });
            //Initialization of treeviews
            $('#tree1').treed();
            $('#treelegenda').treed();
            $('.select2').select2();

            //Initialize Select2 Elements
            $('.select2bs4').select2({
                theme: 'bootstrap4'
            });
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovation_admindokumen-GetDokumen?random=" + random + "&level=" + this.leveluser + "&iduser=" + this.iduser).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        document.getElementById("tree1").innerHTML = '';
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        for (var i = 0; i < this.datamaster.length; i++) {
                            if (this.datamaster[i].id_parent == null) {
                                var buttonhapus = document.createElement("BUTTON");
                                var textbuttonhapus = document.createTextNode("x");
                                buttonhapus.setAttribute("id", 'hapus_' + this.datamaster[i].id);
                                buttonhapus.classList.add("btn-danger");
                                buttonhapus.onclick = function () {
                                    document.getElementById('kodetemp').value = this.id;
                                    document.getElementById('prosesdata').click();
                                };
                                buttonhapus.appendChild(textbuttonhapus);

                                var buttontambah = document.createElement("BUTTON");
                                var textbuttontambah = document.createTextNode("+");
                                buttontambah.setAttribute("id", 'tambah_' + this.datamaster[i].id);
                                buttontambah.classList.add("btn-success");
                                buttontambah.onclick = function () {
                                    document.getElementById('kodetemp').value = this.id;
                                    document.getElementById('prosesdata').click();
                                };
                                buttontambah.appendChild(textbuttontambah);

                                var buttonedit = document.createElement("BUTTON");
                                var textbuttonedit = document.createTextNode("e");
                                buttonedit.setAttribute("id", 'edit_' + this.datamaster[i].id);
                                buttonedit.classList.add("btn-info");
                                buttonedit.onclick = function () {
                                    document.getElementById('kodetemp').value = this.id;
                                    document.getElementById('prosesdata').click();
                                };
                                buttonedit.appendChild(textbuttonedit);

                                var node = document.createElement("li");
                                node.setAttribute("id", this.datamaster[i].id);
                                var textnode = document.createTextNode(" " + this.datamaster[i].nama + " ");
                                node.appendChild(buttonhapus);
                                if (this.datamaster[i].namajenismenu == 'Folder') {
                                    node.appendChild(buttontambah);
                                }
                                if (this.datamaster[i].namajenismenu != 'Dokumen') {
                                    node.appendChild(buttonedit);
                                }

                                if (this.datamaster[i].namajenismenu != 'Folder') {
                                    var link = document.createElement("a");
                                    var textlink = document.createTextNode(" " + this.datamaster[i].nama + " ");
                                    link.id = 'link_' + this.datamaster[i].id;

                                    if (this.datamaster[i].namajenismenu != 'Tautan') {
                                        link.href = this.folder_foto + this.datamaster[i].filenya_dokumen;
                                        link.title = this.datamaster[i].filenya_dokumen;
                                    }
                                    else {
                                        link.title = this.datamaster[i].tautan;
                                        link.href = this.datamaster[i].tautan;
                                        link.setAttribute("target", "_blank");
                                    }
                                    link.appendChild(textlink);
                                    node.appendChild(link);
                                }
                                else {
                                    node.appendChild(textnode);
                                }

                                document.getElementById("tree1").appendChild(node);
                            }
                            else {
                                var buttonhapus = document.createElement("BUTTON");
                                var textbuttonhapus = document.createTextNode("x");
                                buttonhapus.setAttribute("id", 'hapus_' + this.datamaster[i].id);
                                buttonhapus.classList.add("btn-danger");
                                buttonhapus.onclick = function () {
                                    document.getElementById('kodetemp').value = this.id;
                                    document.getElementById('prosesdata').click();
                                };
                                buttonhapus.appendChild(textbuttonhapus);

                                var buttontambah = document.createElement("BUTTON");
                                var textbuttontambah = document.createTextNode("+");
                                buttontambah.setAttribute("id", 'tambah_' + this.datamaster[i].id);
                                buttontambah.classList.add("btn-success");
                                buttontambah.onclick = function () {
                                    document.getElementById('kodetemp').value = this.id;
                                    document.getElementById('prosesdata').click();
                                };
                                buttontambah.appendChild(textbuttontambah);

                                var buttonedit = document.createElement("BUTTON");
                                var textbuttonedit = document.createTextNode("e");
                                buttonedit.setAttribute("id", 'edit_' + this.datamaster[i].id);
                                buttonedit.classList.add("btn-info");
                                buttonedit.onclick = function () {
                                    document.getElementById('kodetemp').value = this.id;
                                    document.getElementById('prosesdata').click();
                                };
                                buttonedit.appendChild(textbuttonedit);

                                var node = document.createElement("li");
                                node.setAttribute("id", this.datamaster[i].id);
                                var textnode = document.createTextNode(" " + this.datamaster[i].nama + " ");
                                node.appendChild(buttonhapus);
                                if (this.datamaster[i].namajenismenu == 'Folder') {
                                    node.appendChild(buttontambah);
                                }
                                if (this.datamaster[i].namajenismenu != 'Dokumen') {
                                    node.appendChild(buttonedit);
                                }

                                if (this.datamaster[i].namajenismenu != 'Folder') {
                                    var link = document.createElement("a");
                                    var textlink = document.createTextNode(" " + this.datamaster[i].nama + " ");
                                    link.id = 'link_' + this.datamaster[i].id;

                                    if (this.datamaster[i].namajenismenu != 'Tautan') {
                                        link.href = this.folder_foto + this.datamaster[i].filenya_dokumen;
                                        link.title = this.datamaster[i].filenya_dokumen;
                                    }
                                    else {
                                        link.title = this.datamaster[i].tautan;
                                        link.href = this.datamaster[i].tautan;
                                        link.setAttribute("target", "_blank");
                                    }
                                    link.appendChild(textlink);
                                    node.appendChild(link);
                                }
                                else {
                                    node.appendChild(textnode);
                                }

                                var ul = document.createElement("ul");
                                ul.setAttribute("id", "ul" + this.datamaster[i].id);
                                ul.appendChild(node);
                                document.getElementById(this.datamaster[i].id_parent).appendChild(ul);
                            }
                        }
                        $('#tree1').treed();
                    }
                    else {
                        this.datamaster = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                this.datamaster = [];
                this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        tambahdata(id_parent, level) {
            this.id = null;
            this.id_parent = id_parent;
            this.level = level;
            this.defaultSelectedjenismenu = {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            };
            this.selectedjenismenu = '';
            this.filenya_dokumen = '';
            this.files = [];
            this.defaultSelectedStatusTampil = {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            };
            this.selectedtampilpublik = '';
            this.nama = '';
            this.urut = '';
            $('#costumModalpeta').modal('show');
        },
        validasidata() {
            if (document.getElementById('nama').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('nama').focus();
                return false;
            }
            if (document.getElementById('urut').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('urut').focus();
                return false;
            }
            if ((this.selectedjenismenu == '') || (this.selectedjenismenu === null) || (this.selectedjenismenu === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Jenis Dokumen..',
                });
                return false;
            }
            if (this.selectedjenismenu == '2') {
                if ((this.files.length == 0)) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan Dokumen..',
                    });
                    return false;
                }
                for (let i = 0; i < this.files.length; i++) {
                    if (document.getElementById('pic' + i).value == '') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: 'Mohon Upload File',
                        });
                        return false;
                    }
                }
            }
            if (this.selectedjenismenu == '3') {
                if ((this.tautan == '') || (this.tautan === null) || (this.tautan === undefined)) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan Tautan Dokumen..',
                    });
                    return false;
                }
            }
            if ((this.selectedtampilpublik == '') || (this.selectedtampilpublik === null) || (this.selectedtampilpublik === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Jenis Tampil Dokumen..',
                });
                return false;
            }
            this.validasi = true;
            return;
        },
        onChange() {
            this.files.push(...this.$refs.file.files);
        },
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
            document.getElementById('drag_drop').style.borderColor = '#333';
        },
        dragleave() {
            this.isDragging = false;
            document.getElementById('drag_drop').style.borderColor = '#ccc';
        },
        drop(e) {
            e.preventDefault();
            this.$refs.file.files = e.dataTransfer.files;
            this.onChange();
            this.isDragging = false;
        },
        remove(i) {
            this.files.splice(i, 1);
        },
        upload() {
            const files = this.files;
            var fd = new FormData();
            files.forEach((file) => {
                fd.append("fileToUpload", file, file.name);
                fd.append("folderToUpload", 'filenya_dokumen');
                const mainAPI = axios.create({
                    baseURL: process.env.VUE_APP_URL_API,
                    headers: {
                        "Content-Type": "form-data",
                        Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                    },
                });
                mainAPI.post("parastapainnovationimg-FilesUpload", fd, {
                    onUploadProgress: function (uploadEvent) {
                        document.getElementById('persennyapic' + files.indexOf(file)).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                        document.getElementById('tulisanpersenpic' + files.indexOf(file)).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    }
                }).then(
                    Response => {
                        document.getElementById('suksesnyapic' + files.indexOf(file)).innerHTML = Response.data.message;
                        if (Response.data.filename != undefined) {
                            document.getElementById('pic' + files.indexOf(file)).value = Response.data.filename;
                        }
                    }

                ).catch(function (e) {
                    document.getElementById('suksesnyapic' + files.indexOf(file)).innerHTML = Response.data.message;
                    document.getElementById('pic' + files.indexOf(file)).value = '';
                    //console.log(e);
                }
                )
            });
            return false;
        },
        simpanlayer() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            var tempfiles = '';
            for (let i = 0; i < this.files.length; i++) {
                if (i == 0) {
                    tempfiles = tempfiles + document.getElementById('pic' + i).value;
                }
                else {
                    tempfiles = tempfiles + ',' + document.getElementById('pic' + i).value;
                }
            }
            var fd = new FormData();
            fd.append("id_parent", this.id_parent);
            fd.append("level", this.level);
            fd.append("nama", this.nama);
            fd.append("urut", this.urut);
            fd.append("jenis", this.selectedjenismenu);
            fd.append("tempfiles", tempfiles);
            fd.append("tampilpublik", this.selectedtampilpublik);
            fd.append("tautan", this.tautan);
            fd.append("createdby", JSON.parse(localStorage.getItem("usistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });

            mainAPI.post("parastapainnovation_dokumen-AddDokumen", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        return false;
                    }
                    else {
                        swal.fire({
                            title: "Informasi",
                            text: Response.data.message,
                            icon: "success"
                        }).then(function () {
                            window.location.replace("/Dokumen");
                        });
                        $('.swal2-container').css("z-index", '999999');
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                }
            )
        },
        updatelayer() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            var tempfiles = '';
            for (let i = 0; i < this.files.length; i++) {
                if (i == 0) {
                    tempfiles = tempfiles + document.getElementById('pic' + i).value;
                }
                else {
                    tempfiles = tempfiles + ',' + document.getElementById('pic' + i).value;
                }
            }
            //alert(this.selectedapipeta);
            var fd = new FormData();
            fd.append("id", this.id);
            fd.append("id_parent", this.id_parent);
            fd.append("level", this.level);
            fd.append("nama", this.nama);
            fd.append("urut", this.urut);
            fd.append("jenis", this.selectedjenismenu);
            fd.append("tempfiles", tempfiles);
            fd.append("tampilpublik", this.selectedtampilpublik);
            fd.append("tautan", this.tautan);
            fd.append("updatedby", JSON.parse(localStorage.getItem("usistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });

            mainAPI.post("parastapainnovation_admindokumen-UpdateDokumen", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        return false;
                    }
                    else {
                        swal.fire({
                            title: "Informasi",
                            text: Response.data.message,
                            icon: "success"
                        }).then(function () {
                            window.location.replace("/Dokumen");
                        });
                        $('.swal2-container').css("z-index", '999999');
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                }
            )

        },
        async prosesdata() {
            //alert(document.getElementById('kodetemp').value);
            var cek = document.getElementById('kodetemp').value;
            if (cek == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Operasi data gagal..',
                });
                return false;
            }
            var tempcek = cek.split("_");
            if (tempcek.length == 0) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Operasi data gagal..',
                });
                return false;
            }
            var operasi = tempcek[0];
            var idata = tempcek[1];
            if (operasi == 'hapus') {
                swal.fire({
                    title: "Konfirmasi",
                    text: "Yakin Hendak Hapus Data?",
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: "Batal",
                    confirmButtonColor: "#15B9D9",
                    cancelButtonColor: "#ffaa05",
                    confirmButtonText: "Hapus"
                }).then((result) => {
                    if (result.isConfirmed) {
                        const data = { kode: idata, deletedby: JSON.parse(localStorage.getItem("usistem")) }
                        const mainAPI = axios.create({
                            baseURL: process.env.VUE_APP_URL_API,
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                                "Content-Type": "application/x-www-form-urlencoded",
                            },
                        });
                        mainAPI.post("parastapainnovation_dokumen-DeleteDokumen", data).then(
                            Response => {
                                if (Response.data.response == 'error') {
                                    swal.fire('Peringatan', Response.data.message, 'error');
                                }
                                else {
                                    swal.fire('Informasi', 'Data telah dihapus..', 'success').then(function () {
                                        window.location.replace("/Dokumen");
                                    });
                                }
                            }
                        ).catch(
                            error => {
                                swal.fire('Peringatan', 'Terjadi Kesalahan Format Data', 'error');
                            }
                        )

                    }
                });
                return false;
            }
            if (operasi == 'edit') {
                this.halamanloading = true;
                const mainAPI = axios.create({
                    baseURL: process.env.VUE_APP_URL_API,
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                    },
                });
                var random = Math.random();
                await mainAPI.get("parastapainnovation_admindokumen-GetIDDokumenBy?random=" + random + "&level=" + this.leveluser + "&iduser=" + this.iduser + "&id=" + idata).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        if (this.datapesan == 'data diketemukan') {
                            this.id = Response.data.content.data[0].id;
                            this.id_parent = Response.data.content.data[0].id_parent;
                            this.urut = Response.data.content.data[0].urut;
                            this.level = Response.data.content.data[0].level;
                            this.nama = Response.data.content.data[0].nama;
                            this.defaultSelectedjenismenu = {
                                code: Response.data.content.data[0].jenis,
                                label: Response.data.content.data[0].namajenismenu,
                                tag: Response.data.content.data[0].jenis,
                            };
                            this.selectedjenismenu = Response.data.content.data[0].jenis;
                            this.defaultSelectedStatusTampil = {
                                code: Response.data.content.data[0].tampilpublik,
                                label: Response.data.content.data[0].namastatustampil,
                                tag: Response.data.content.data[0].tampilpublik,
                            };
                            this.selectedtampilpublik = Response.data.content.data[0].tampilpublik;
                            this.files.push(Response.data.content.data[0].filenya_dokumen);

                            $('#costumModalpeta').modal('show');
                        }
                        else {
                            this.datamaster = [];
                        }
                        this.halamanloading = false;
                    }
                ).catch(error => {
                    console.log(error);
                    this.datamaster = [];
                    this.ClearlocalStorage();
                    this.halamanloading = false;
                });
            }
            if (operasi == 'tambah') {
                this.halamanloading = true;
                const mainAPI = axios.create({
                    baseURL: process.env.VUE_APP_URL_API,
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                    },
                });
                var random = Math.random();
                await mainAPI.get("parastapainnovation_admindokumen-GetIDDokumenBy?random=" + random + "&level=" + this.leveluser + "&iduser=" + this.iduser + "&id=" + idata).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        if (this.datapesan == 'data diketemukan') {

                            this.id = null;
                            this.id_parent = Response.data.content.data[0].id;
                            this.level = Response.data.content.data[0].level + 1;
                            this.defaultSelectedjenismenu = {
                                code: 0,
                                label: 'Pilih Salah Satu',
                                tag: '',
                            };
                            this.selectedjenismenu = '';
                            this.filenya_dokumen = '';
                            this.files = [];
                            this.defaultSelectedStatusTampil = {
                                code: 0,
                                label: 'Pilih Salah Satu',
                                tag: '',
                            };
                            this.selectedtampilpublik = '';
                            this.nama = '';
                            this.urut = '';
                            $('#costumModalpeta').modal('show');
                        }
                        else {
                            this.datamaster = [];
                        }
                        this.halamanloading = false;
                    }
                ).catch(error => {
                    console.log(error);
                    this.datamaster = [];
                    this.ClearlocalStorage();
                    this.halamanloading = false;
                });
            }
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.AmbilDataReff();
        this.ambildata();
        this.InisialisasiTree();
    }
}
</script>
<style></style>